import React, { useState, useEffect, useReducer, useRef } from 'react';
import { SFuncModal } from 'shj-components'
import {saveCalculationFormula} from '@/services/integrationConfig'
import {
  Form,
  DatePicker,
  Button,
  Select,
  Divider,
  Row,
  Col,
  message,
  Input,
  Radio,
  Space,
  InputNumber,
  Modal,
  Switch,
} from 'antd';

const TextArea = Input.TextArea;
const RadioGroup = Radio.Group;
const Option = Select.Option;
import moment from 'moment';
import { modalExpressRunFn } from './expressRun';

// @ts-ignore
export function modalAddOrEditFn({ fn, ...rest }) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `${rest?.id ? '编辑' : '新增'}`,
    width: 600,
    vanish: true,
    content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}

// @ts-ignore
const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
  const [form] = Form.useForm();
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);

  useEffect(() => {
    initFn();
  }, []);

  const initFn = () => {
    if (rest?.id) {
      // 回显数据
      form.setFieldsValue({
        name: rest.name,
        description: rest.description,
        formula: rest.formula,
      });
    }
  };
  // 重置
  const onReset = () => {
    form.resetFields();
  };
  const onExpress = () => {
    if (form.getFieldValue('formula')) {
      modalExpressRunFn(form.getFieldValue('formula'));
    } else {
      message.error('请输入表达式');
      return false;
    }
  };
  // 提交
  const onFinish = (values: any) => {
    const { id } = rest;
    let newValues = {
      ...values,
    };
    setAddOrEditFooterLoading(true);
    saveCalculationFormula({ ...newValues, ...(id && { id }) })
      .then((resp: any) => {
        setAddOrEditFooterLoading(false);
        message.info(resp?.message || '操作成功');
        onClose();
        fn && fn();
      })
      .finally(() => {
        setAddOrEditFooterLoading(false);
      });
  };
  const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 24 },
  };
  return (
    <div>
      <Form form={form} layout={'vertical'} onFinish={onFinish} style={{ padding: 15 }}>
        <Form.Item
          label="表达式名称"
          name="name"
          {...formItemLayout}
          rules={[{ required: true, message: '请输入表达式名称' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="表达式描述" name="description" {...formItemLayout}>
          <TextArea rows={2} />
        </Form.Item>
        <Form.Item
          label="表达式内容"
          name="formula"
          {...formItemLayout}
          rules={[{ required: true, message: '请输入表达式内容' }]}
        >
          <TextArea rows={5} />
        </Form.Item>
        <Form.Item>
          <Row>
            <Col span={24}>
              <Divider />
            </Col>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button htmlType="button" onClick={onClose} style={{ marginLeft: '8px' }}>
                取消
              </Button>
              <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }} loading={addOrEditFooterLoading}>
                保存
              </Button>
              <Button type="primary" style={{ margin: '0 8px' }} onClick={onExpress}>
                结果演算
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </div>
  );
};
